import { type Schema, SchemaType, Tag } from "@ext/markdown/core/render/logic/Markdoc";

/**
 * The tag MdParser leaves in place of a comment. It is inline so that the tag transformer keeps it a
 * node wherever it stands; on a line of its own the comment is a block, inside a line an inline node.
 */
export const sourceComment: Schema = {
	render: "Source-comment",
	attributes: {
		hex: { type: String },
	},
	selfClosing: true,
	type: SchemaType.inline,
	transform: () => new Tag("Source-comment", {}),
};
